import { EnumProductType } from '@/types/enum-product-type'

function normalizeProductType(productType?: string | null) {
  return productType ? productType.toLowerCase() : undefined
}

/**
 * Propriedades de tipo de produto para eventos da Brevo.
 * `product_type` é o tipo do produto como vem da API (`postgraduate`,
 * `course`, `webinar`, `track`...). Mantém as flags legadas `is_pos` e
 * `is_track` e adiciona `is_course` e `is_webinar`.
 */
export function getBrevoProductProperties(productType?: string | null) {
  const type = normalizeProductType(productType)

  return {
    product_type: type,
    is_pos: type === EnumProductType.POSTGRADUATE,
    is_track: type === EnumProductType.TRACK,
    is_course: type === EnumProductType.COURSE,
    is_webinar: type === EnumProductType.WEBINAR,
  }
}

/**
 * Tipos de produto de um pedido, para eventos da Brevo com vários itens.
 * `product_types` lista os tipos distintos; `product_type` só vem preenchido
 * quando todos os itens têm o mesmo tipo (pedido misto não tem um único tipo).
 */
export function getBrevoProductTypes(
  productTypes: ReadonlyArray<string | null | undefined>
) {
  const types = [
    ...new Set(
      productTypes
        .map(normalizeProductType)
        .filter((type): type is string => Boolean(type))
    ),
  ]

  return {
    product_type: types.length === 1 ? types[0] : undefined,
    product_types: types,
    has_pos: types.includes(EnumProductType.POSTGRADUATE),
    has_course: types.includes(EnumProductType.COURSE),
    has_webinar: types.includes(EnumProductType.WEBINAR),
    has_track: types.includes(EnumProductType.TRACK),
  }
}
